const WhyChoose = () => {
  return (
    <>
      <div className=" bg-gray-200 py-20">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-10">
            <div className="lg:w-1/3 ">
              <h5 className="uppercase mb-2 from-[#a200be] to-[#246BFD] bg-gradient-to-tl text-6xl font-bold bg-clip-text text-transparent">
                Why <br />
                Choose <br />
                Us
              </h5>
              <h2 className="text-3xl md:text-4xl text-gray-800 leading-snug">
                Save your time with <br />a lot of features
              </h2>
            </div>
            <div className="lg:w-2/3 border-l border-gray-300 pl-6">
              <div className="flex space-x-6">
                <div className="flex-1 bg-white text-center w-48 rounded-lg p-6">
                  <img
                    src={"/assets/1.png"}
                    alt="Fast Performance"
                    className="mx-auto mb-4 w-20 h-20"
                  />
                  <h5 className="text-lg slider_text font-semibold ">
                    Comprehensive Visibility
                  </h5>
                </div>

                <div className="flex-1 bg-white text-center   rounded-lg p-6">
                  <img
                    src={"/assets/2.png"}
                    alt="Standard Code"
                    className="mx-auto mb-4 w-20 h-20"
                  />
                  <h5 className="text-lg slider_text font-semibold ">
                    Profit-Centric Tools
                  </h5>
                </div>
              </div>
              <div className="flex space-x-6 mt-6">
                <div className="flex-1 bg-white text-center   rounded-lg p-6">
                  <img
                    src={"/assets/3.png"}
                    alt="Responsive Design"
                    className="mx-auto mb-4 w-20 h-20"
                  />
                  <h5 className="text-lg slider_text font-semibold ">
                    Data-Driven Decisions
                  </h5>
                </div>

                <div className="flex-1 bg-white text-center  rounded-lg p-6">
                  <img
                    src={"/assets/4.png"}
                    alt="Quick Support"
                    className="mx-auto mb-4 w-20 h-20"
                  />
                  <h5 className="text-lg slider_text font-semibold ">
                    Quick Support
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WhyChoose;
